import React, { useEffect, useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import {
  getMonitors,
  getLatestStoredImages,
  addCCCapProject,
} from '../utils/bedrockAPI';
import './MonitorSelection.css';

const MONITOR_LABELS = {
  house: 'House',
  neighbor: 'Neighbor',
  street: 'Street',
  driveway: 'Driveway',
};

export default function MonitorSelectionModal({
  show,
  cap,
  project,
  integration,
  setShowMonitorSelectionWindow,
  ...props
}) {
  const [monitorCap, setMonitorCap] = useState(cap);
  const [cams, setCams] = useState(null);
  const [url, setUrls] = useState(null);
  const [selectedMonitors, setSelectedmonitors] = useState([]);

  useEffect(() => {
    if (cap) {
      setMonitorCap(cap);
    }
  }, [cap]);

  useEffect(() => {
    async function savedImages() {
      const tempCams = await getMonitors(monitorCap);
      setCams(tempCams);
      const tempSavedUrls = await getLatestStoredImages(monitorCap);
      setUrls(tempSavedUrls);
    }
    if (monitorCap) {
      savedImages();
    }
  }, [monitorCap]);

  function toggleMonitor(monitorId) {
    if (selectedMonitors.includes(monitorId)) {
      setSelectedmonitors(selectedMonitors.filter(m => m !== monitorId));
    } else {
      setSelectedmonitors([...selectedMonitors, monitorId]);
    }
  }

  function renderMonitorOption(direction, camera) {
    if (!camera?.medium?.monitorId || !url?.[camera.medium.monitorId]?.url) {
      return null;
    }

    const monitorId = camera.high.monitorId;
    const isSelected = selectedMonitors.includes(monitorId);

    return (
      <button
        key={direction}
        type="button"
        className={`monitor-selection-option${isSelected ? ' monitor-selection-option--selected' : ''}`}
        onClick={() => toggleMonitor(monitorId)}
      >
        <img
          src={url[camera.medium.monitorId].url}
          alt={MONITOR_LABELS[direction] || direction}
        />
        <span className="monitor-selection-label">
          {MONITOR_LABELS[direction] || direction}
        </span>
      </button>
    );
  }

  async function addUserIntegration(e) {
    e.preventDefault();
    if (cap && project && integration?.integration) {
      await addCCCapProject(integration, cap, project, selectedMonitors);
    }
    setShowMonitorSelectionWindow(false);
  }

  const hasImages = url && cams?.house?.medium?.monitorId && url[cams.house.medium.monitorId];

  return (
    <Modal
      show={show}
      onHide={() => setShowMonitorSelectionWindow(false)}
      className="monitor-selection-modal"
      aria-labelledby="monitor-selection-title"
      {...props}
    >
      <Modal.Header closeButton>
        <Modal.Title id="monitor-selection-title">
          Select views to sync with Company Cam
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {hasImages ? (
          <div className="monitor-selection-grid monitor-selection-grid-2x2">
            {renderMonitorOption('house', cams.house)}
            {renderMonitorOption('neighbor', cams.neighbor)}
            {renderMonitorOption('street', cams.street)}
            {renderMonitorOption('driveway', cams.driveway)}
          </div>
        ) : (
          <p className="monitor-selection-loading">Loading camera views…</p>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button
          className="btn-brand-outline btn-compact"
          onClick={() => setShowMonitorSelectionWindow(false)}
        >
          Cancel
        </Button>
        <Button
          className="btn-brand-dark btn-compact"
          onClick={addUserIntegration}
          disabled={selectedMonitors.length === 0}
        >
          Start Daily Image Sync
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
